import request from '@/utils/request'

// history列表
export const getTableList = params =>
  request.post('/workflow-api/credit-apply/applylist/page', params)

// batch table list
export const getBatchTable = params =>
  request.post('/workflow-api/credit-batch/apply/page', params)

// 获取css详情
export const getCssDetail = params =>
  request.get(`/workflow-api/credit-css/approve/detail/${params.bpmId}`)
